export default __webpack_public_path__ + "images/Z6.5879810.png";